import SportIcon from '../SportIcon/SportIcon';
import styles from './WelcomeMessage.module.css';

const WelcomeMessage = ({ name, sport }) => {
  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return 'Good morning';
    if (hour < 18) return 'Good afternoon';
    return 'Good evening';
  };

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.greeting}>
        {getGreeting()},{' '}
        <span className={styles.nameWithIcon}>
          {name}
          {sport && (
            <span className={styles.icon}>
              <SportIcon sport={sport} size={22} />
            </span>
          )}
        </span>
      </h2>
    </div>
  );
};

export default WelcomeMessage;
